"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderTransformer = void 0;
const lodash_isundefined_1 = __importDefault(require("lodash.isundefined"));
const lodash_isfunction_1 = __importDefault(require("lodash.isfunction"));
const lodash_uniq_1 = __importDefault(require("lodash.uniq"));
const lodash_groupby_1 = __importDefault(require("lodash.groupby"));
class HeaderTransformer {
  constructor(parserOptions) {
    this.headers = null;
    this.receivedHeaders = false;
    this.shouldUseFirstRow = false;
    this.processedFirstRow = false;
    this.headersLength = 0;
    this.parserOptions = parserOptions;
    if (parserOptions.headers === true) {
      this.shouldUseFirstRow = true;
    } else if (Array.isArray(parserOptions.headers)) {
      this.setHeaders(parserOptions.headers);
    } else if (lodash_isfunction_1.default(parserOptions.headers)) {
      this.headersTransform = parserOptions.headers;
    }
  }
  transform(row, cb) {
    if (!this.shouldMapRow(row)) {
      return cb(null, {
        row: null,
        isValid: true
      });
    }
    return cb(null, this.processRow(row));
  }
  shouldMapRow(row) {
    const {
      parserOptions
    } = this;
    if (!this.headersTransform && parserOptions.renameHeaders && !this.processedFirstRow) {
      if (!this.receivedHeaders) {
        throw new Error('Error renaming headers: new headers must be provided in an array');
      }
      this.processedFirstRow = true;
      return false;
    }
    if (!this.receivedHeaders && Array.isArray(row)) {
      if (this.headersTransform) {
        this.setHeaders(this.headersTransform(row));
      } else if (this.shouldUseFirstRow) {
        this.setHeaders(row);
      } else {
        // dont do anything with the headers if we didnt receive a transform or shouldnt use the first row.
        return true;
      }
      return false;
    }
    return true;
  }
  processRow(row) {
    if (!this.headers) {
      return {
        row: row,
        isValid: true
      };
    }
    const {
      parserOptions
    } = this;
    if (!parserOptions.discardUnmappedColumns && row.length > this.headersLength) {
      if (!parserOptions.strictColumnHandling) {
        throw new Error(`Unexpected Error: column header mismatch expected: ${this.headersLength} columns got: ${row.length}`);
      }
      return {
        row: row,
        isValid: false,
        reason: `Column header mismatch expected: ${this.headersLength} columns got: ${row.length}`
      };
    }
    if (parserOptions.strictColumnHandling && row.length < this.headersLength) {
      return {
        row: row,
        isValid: false,
        reason: `Column header mismatch expected: ${this.headersLength} columns got: ${row.length}`
      };
    }
    return {
      row: this.mapHeaders(row),
      isValid: true
    };
  }
  mapHeaders(row) {
    const rowMap = {};
    const {
      headers,
      headersLength
    } = this;
    for (let i = 0; i < headersLength; i += 1) {
      const header = headers[i];
      if (!lodash_isundefined_1.default(header)) {
        const val = row[i];
        // eslint-disable-next-line no-param-reassign
        if (lodash_isundefined_1.default(val)) {
          rowMap[header] = '';
        } else {
          rowMap[header] = val;
        }
      }
    }
    return rowMap;
  }
  setHeaders(headers) {
    var _a;
    const filteredHeaders = headers.filter(h => !!h);
    if (lodash_uniq_1.default(filteredHeaders).length !== filteredHeaders.length) {
      const grouped = lodash_groupby_1.default(filteredHeaders);
      const duplicates = Object.keys(grouped).filter(dup => grouped[dup].length > 1);
      throw new Error(`Duplicate headers found ${JSON.stringify(duplicates)}`);
    }
    this.headers = headers;
    this.receivedHeaders = true;
    this.headersLength = ((_a = this.headers) === null || _a === void 0 ? void 0 : _a.length) || 0;
  }
}
exports.HeaderTransformer = HeaderTransformer;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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